import React from 'react';
import Flexbox from 'flexbox-react';
import { Card } from '@blueprintjs/core';
import ContainerIntroBox from '../../components/goal_performance/ContainerIntroBox.js';
import AssessmentReadOnlyList from '../../components/goal_performance/AssessmentReadOnlyList.js';
import GoalReadOnlyList from '../../components/goal_performance/GoalReadOnlyList.js';
import EmptyStateNotice from '../../components/goal_performance/EmptyStateNotice.js';

const ManagerTabContent = ({
  releaseStatus,
  reviewSubmittedListByManager,
  reviewSubmittedCatGroupListByManager,
  goalSubmittedListByManager,
  reviewRatingByManager,
  reviewRatingLabelByManager,
  goalRatingByManager,
  goalRatingLabelByManager,
  selectedTimeframe,
  resultData,
  managerGlobalRating,
  managerGlobalRatingLabel,
  accountId,
  accountVisibilityConfig,
  subGoalsByGoalId,
  openSubGoals,
  toggleSubGoals,
}) => {
  const hasAssessmentData =
    (reviewSubmittedListByManager?.length || 0) > 0;
  const hasGoalData = (goalSubmittedListByManager?.length || 0) > 0;
  const hasAnyData = hasAssessmentData || hasGoalData;

  return (
    <>
      <Flexbox className="self-assessment-container">
        {!hasAnyData ? (
          <Card className="assessment-answer-container">
            <EmptyStateNotice
              title={
                releaseStatus
                  ? 'Waiting for Manager Review'
                  : 'Review Not Released Yet'
              }
              description={
                releaseStatus
                  ? "Your manager is still working on your performance review. You'll be notified once it's completed."
                  : 'Manager review will be visible once it is released.'
              }
            />
          </Card>
        ) : null}

        {reviewSubmittedListByManager?.length > 0 && (
          <>
            <ContainerIntroBox
              iconType="manager"
              text="Manager's Review of Your Performance"
              description={
                'View feedback from your manager on your performance, strengths, and growth areas'
              }
              rating={reviewRatingByManager}
              ratingLabel={reviewRatingLabelByManager}
              ratingLabels={selectedTimeframe.rating_labels || []}
              finalAssessmentRatingLabel={
                resultData.finalAssessmentRatingLabel
              }
              isRatingEnabledQuestions={
                selectedTimeframe.is_assessment_question_rating
              }
              managerGlobalRating={managerGlobalRating}
              managerGlobalRatingLabel={managerGlobalRatingLabel}
              containerType="assessment"
            />
            <Card className="assessment-answer-container">
              {reviewSubmittedCatGroupListByManager?.length > 0 ? (
                <AssessmentReadOnlyList
                  data={reviewSubmittedCatGroupListByManager}
                  finalAssessmentRating={reviewRatingByManager}
                  weightage={selectedTimeframe.is_weight_allow}
                  ratingLabels={selectedTimeframe.rating_labels || []}
                  isRatingEnabledQuestions={
                    selectedTimeframe.is_assessment_question_rating
                  }
                  accountId={accountId}
                  visibilityConfig={accountVisibilityConfig}
                  isAnswerAllowedOnQuestion={
                    selectedTimeframe?.is_answer_allow_on_question
                  }
                />
              ) : (
                <AssessmentReadOnlyList
                  data={reviewSubmittedListByManager}
                  finalAssessmentRating={reviewRatingByManager}
                  weightage={selectedTimeframe.is_weight_allow}
                  ratingLabels={selectedTimeframe.rating_labels || []}
                  isRatingEnabledQuestions={
                    selectedTimeframe.is_assessment_question_rating
                  }
                  accountId={accountId}
                  visibilityConfig={accountVisibilityConfig}
                  isAnswerAllowedOnQuestion={
                    selectedTimeframe?.is_answer_allow_on_question
                  }
                />
              )}
            </Card>
          </>
        )}

        {goalSubmittedListByManager?.length > 0 && (
          <>
            <ContainerIntroBox
              iconType="manager"
              text="Manager's Review of Your Goal Performance"
              description={
                'View feedback from your manager on your performance, strengths, and growth areas'
              }
              rating={goalRatingByManager}
              ratingLabel={goalRatingLabelByManager}
              ratingLabels={selectedTimeframe.rating_labels || []}
              finalGoalRatingLabel={resultData.finalGoalRatingLabel}
              containerType="goal"
            />
            <Card className="assessment-answer-container">
              <GoalReadOnlyList
                data={goalSubmittedListByManager}
                goalFinalRating={goalRatingByManager}
                weightage={selectedTimeframe.is_weight_allow}
                ratingLabels={selectedTimeframe.rating_labels || []}
                managerView={true}
                subGoalsByGoalId={subGoalsByGoalId}
                openSubGoals={openSubGoals}
                toggleSubGoals={toggleSubGoals}
              />
            </Card>
          </>
        )}
      </Flexbox>
    </>
  );
};

export default ManagerTabContent;
